import React, { useState } from "react";
import {
  LayoutDashboard, Users, Sparkles, GitBranch, Clock,
  FileText, MessageSquare, ShieldAlert, AlertOctagon, DollarSign,
} from "lucide-react";

import CRMDashboard from "./CRMDashboard";
import CRMCustomersTab from "./CRMCustomersTab";
import CRMLeadsTab from "./CRMLeadsTab";
import CRMPipeline from "./CRMPipeline";
import CRMFollowUpsTab from "./CRMFollowUpsTab";
import CRMQuotesTab from "./CRMQuotesTab";
import CRMMessagesTab from "./CRMMessagesTab";
import CRMRiskTab from "./CRMRiskTab";
import CRMIncidentsTab from "./CRMIncidentsTab";
import CRMRevenueSplit from "./CRMRevenueSplit";

const SUBTABS = [
  { key: "dashboard",    label: "Dashboard",     icon: LayoutDashboard, Component: CRMDashboard },
  { key: "customers",    label: "Customers",     icon: Users,           Component: CRMCustomersTab },
  { key: "leads",        label: "Leads",         icon: Sparkles,        Component: CRMLeadsTab },
  { key: "pipeline",     label: "Pipeline",      icon: GitBranch,       Component: CRMPipeline },
  { key: "revenue_split",label: "Revenue Split", icon: DollarSign,      Component: CRMRevenueSplit },
  { key: "followups",    label: "Follow-Ups",    icon: Clock,           Component: CRMFollowUpsTab },
  { key: "quotes",       label: "Quotes",        icon: FileText,        Component: CRMQuotesTab },
  { key: "messages",     label: "Messages",      icon: MessageSquare,   Component: CRMMessagesTab },
  { key: "incidents",    label: "Incidents",     icon: AlertOctagon,    Component: CRMIncidentsTab },
  { key: "risk",         label: "Risk",          icon: ShieldAlert,     Component: CRMRiskTab },
];

export default function CRM() {
  const [sub, setSub] = useState("dashboard");
  const Active = SUBTABS.find((t) => t.key === sub)?.Component;
  return (
    <div data-testid="crm-tab" className="space-y-5">
      <div className="rounded-3xl border border-cyan/25 bg-gradient-to-br from-cyan/[0.08] via-cyan/[0.02] to-transparent p-5 relative overflow-hidden">
        <div className="absolute -top-10 -right-10 w-48 h-48 rounded-full bg-cyan/10 blur-3xl pointer-events-none" />
        <div className="relative flex items-center justify-between gap-4 flex-wrap">
          <div>
            <div className="label-caps text-cyan text-[10px]">Customer relationship management</div>
            <h2 className="font-serif text-3xl text-white mt-0.5">Plenty Rydez CRM</h2>
            <p className="text-white/60 text-xs mt-1 max-w-xl">
              Every customer, lead, booking, deposit, message and follow-up unified into one
              luxury operating system. Nothing here duplicates your fleet data — it wraps it.
            </p>
          </div>
        </div>
      </div>

      {/* Sub-nav */}
      <div className="glass rounded-full p-1 flex flex-wrap gap-1">
        {SUBTABS.map((t) => (
          <button
            key={t.key}
            data-testid={`crm-subtab-${t.key}`}
            onClick={() => setSub(t.key)}
            className={`px-4 py-2 rounded-full text-xs label-caps tracking-widest transition-colors inline-flex items-center gap-1.5 ${
              sub === t.key ? "bg-cyan text-black font-bold" : "text-white/60 hover:text-white"
            }`}
          >
            <t.icon size={12} /> {t.label}
          </button>
        ))}
      </div>

      {Active ? <Active /> : null}
    </div>
  );
}
